export default __webpack_public_path__ + "static/media/mac-app-logo-128@2x.e7a57e6f.png";